import {QuerySampleItem} from './types';

export const COMPLEX_SAMPLES: QuerySampleItem[] = [
    {
        id: 'or-groups-and',
        title: 'OR groups combined with AND',
        query: '(refund OR reimbursement) AND (delayed OR late)',
        description: 'Finds texts where one term from the first group and one term from the second group are both present.',
    },
    {
        id: 'or-groups-exclude',
        title: 'Grouped OR with exclusions',
        query: '(refund OR reimbursement) AND (delayed OR late) -spam -(test OR dummy)',
        description: 'Combines grouped alternatives with required matches and multiple exclusions.',
    },
    {
        id: 'nested-precedence',
        title: 'Nested grouping and precedence',
        query: '((refund OR reimbursement) AND delayed) OR escalated',
        description: 'Either escalated alone, or both a payment term and delayed together.',
    },
    {
        id: 'deep-nesting',
        title: 'Deeply nested OR groups',
        query: '(refund OR reimbursement) AND (delayed OR (late AND urgent))',
        description: 'Nested parentheses control which combinations are allowed.',
    },
    {
        id: 'phrase-with-keywords',
        title: 'Phrase plus keyword groups',
        query: '"not satisfied" AND (refund OR chargeback) -spam',
        description: 'Requires an exact phrase plus at least one keyword from a group, while excluding spam.',
    },
    {
        id: 'multi-phrase-complex',
        title: 'Multiple phrases with exclusions',
        query: '"not satisfied" AND "speak to manager" -spam -(test OR dummy)',
        description: 'Two required phrases combined with grouped exclusions.',
    },
    {
        id: 'boost-synonyms',
        title: 'Boost preferred synonym',
        query: '(refund^3 OR reimbursement) AND delayed',
        description: 'Refund matches rank higher than reimbursement when both could match.',
    },
    {
        id: 'datetime-with-text',
        title: 'Date range with text filter',
        query: 'event_datetime:[2026-06-01T00:00:00 TO 2026-06-30T23:59:59] AND (refund OR reimbursement)',
        description: 'Restricts results to a date range and adds a text condition on top.',
    },
    {
        id: 'field-date-text',
        title: 'Field + date + text combined',
        query: 'event_datetime:[2026-06-01T00:00:00 TO 2026-06-30T23:59:59] AND event_text:(refund OR chargeback) AND -event_text:spam',
        description: 'Date filter with field-scoped keywords and field-scoped exclusion.',
    },
    {
        id: 'field-agent-customer',
        title: 'Agent and customer fields together',
        query: 'event_agent_text:policy AND event_customer_text:(angry OR frustrated) -event_text:spam',
        description: 'Different speaker roles combined in one query.',
    },
    {
        id: 'nested-fuzzy-phrase',
        title: 'Fuzzy terms inside a grouped query',
        query: '(cancelation~2 OR cancellation) AND "customer service"~3 -test',
        description: 'Mixes fuzzy matching, phrase proximity, grouping, and exclusion in one query.',
    },
    {
        id: 'mixed-wildcard-fuzzy-phrase',
        title: 'Wildcard, fuzzy, and phrase combined',
        query: '(cancel* OR cancelation~2) AND "customer service" AND refund*',
        description: 'Prefix wildcard, fuzzy OR, exact phrase, and another wildcard together.',
    },
    {
        id: 'full-dashboard-query',
        title: 'Full dashboard-style query',
        query: 'event_datetime:[2026-06-01T00:00:00 TO 2026-06-30T23:59:59] AND event_text:(refund OR reimbursement) AND event_customer_text:(angry OR frustrated) AND -event_text:spam -(test OR dummy)',
        description: 'Date range, multiple field groups, and exclusions in a single query.',
    },
];
